import RestApiModel from "@/api/Model/RestApiModel";
import { fisgApi } from '@/api';

class GridOptions extends RestApiModel {
  static getResourceEndpoint() {
    return '/fisg';
  }

  static list(tableIdentifier) {
    return fisgApi.get('/GridOptions', { params: { TableIdentifier: tableIdentifier } });
  }
}

export default GridOptions;
